import React from "react";
import {inject, observer} from "mobx-react";
import {observable, computed} from "mobx";
import {Box, Tab, Tabs} from "@material-ui/core";
import {IManagementStore} from "Stores/Management/types";
import filterByTableColumns from "@src/Tools/filterByTableColumns";
import PersonsTable from "./PersonsTable/PersonsTable";
import {Values} from "@src/Tools/Values";
import {Person} from "@src/Interfaces/Entity/Person";
import {IAuthStore} from "@src/Stores/Auth/types";
import PersonDialog from "@src/Components/Pages/Main/Content/Persons/PersonDialog/PersonDialog";
import {FullWidthFlexBox} from "@src/Shared/Components/FullWidthFlexBox";
import {ItemListPageContentWrapper, ItemListPageTabWrapper} from "@src/Shared/Layout/styles";
import {AddButton} from "@src/Shared/Components/AddButton/AddButton";
import FullWidthSearch from "@src/Shared/Components/FullWidthSearch/FullWidthSearch";
import {STGrid} from "@src/Components/Pages/Main/Content/Locations/LocationsContent/styles";
import ResultsAreEmptyLabel from "@src/Components/Ui/ResultsAreEmpty";

interface IProps {
    management?: IManagementStore;
    auth?: IAuthStore;
}

@inject("auth", "management")
@observer
class PersonsContent extends React.Component<IProps> {
    @observable searchText: string = "";
    @observable showAddPersonDialog: boolean = false;
    @observable editPerson: Person = null;
    
    @computed get filteredPersons() {
        return filterByTableColumns<Person>(
            this.props.management.persons,
            this.searchText
        );
    }

    handleChange = (text: string) => {
        this.searchText = text;
    };

    onAddPersonButtonClick() {
        this.editPerson = null;
        this.showAddPersonDialog = true;
    }
    
    onEditPersonButtonClick(person: Person) {
        this.editPerson = person;
        this.showAddPersonDialog = true;
    }
    
    async onPersonsModalConfirm() {
        this.showAddPersonDialog = false;
        this.editPerson = null;
        await this.props.management.getPersons();
    }
    
    onPersonsModalCancel() {
        this.editPerson = null;
        this.showAddPersonDialog = false;
    }

    render() {
        return (
            <>
                <FullWidthFlexBox>
                    <ItemListPageTabWrapper>
                        <Tabs
                            value={0}
                            indicatorColor="primary"
                            textColor="primary"
                            variant={"standard"}
                        >
                            <Tab label={Values.getLocalizationValue("persons")}/>
                        </Tabs>
                    </ItemListPageTabWrapper>

                    {this.props.auth.user.location.primary &&
                        <AddButton
                            onClick={() => this.onAddPersonButtonClick()}
                            text={Values.getLocalizationValue("addPerson")}
                        />
                    }
                </FullWidthFlexBox>

                <ItemListPageContentWrapper>
                    <Box>
                        <FullWidthSearch
                            value={this.searchText}
                            onChange={(text: string) => this.handleChange(text)}
                        />

                        <STGrid item xs>
                            {this.filteredPersons.length > 0 ? (
                                <PersonsTable
                                    persons={this.filteredPersons}
                                    onEditPersonClick={this.onEditPersonButtonClick.bind(this)}
                                />
                            ) : (
                                <ResultsAreEmptyLabel/>
                            )}
                        </STGrid>
                    </Box>
                </ItemListPageContentWrapper>

                {this.showAddPersonDialog && (
                    <PersonDialog
                        initialValues={this.editPerson}
                        onConfirm={() => this.onPersonsModalConfirm()}
                        onClose={() => {
                            this.onPersonsModalCancel()
                        }}
                        isOpened={this.showAddPersonDialog}
                    />
                )}
            </>
        );
    }
}

export default PersonsContent;
